import Answer from './Answer';

export default Answer;
